/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const PickupContactInformation = ({
  contactDetails,
}) => {
  const {
    isAdmin, RL_Name, RL_Contact, RL_Email, redacted,
  } = useSelector((state) => state);

  return (
    <>
      {contactDetails?.Customers?.map((contact) => (
        <section key={`${(contact?.Name?.Names) || 'redacted'}`}>
          <p>*****{RL_Contact}*****</p>
          <article className="justify-between">
            <p>{RL_Name}: {isAdmin ? (contact?.Name?.Names?.map((name) => name.NamePart).join(' ') || '') : redacted}</p>
          </article>
          <article className="justify-between">
            <p>{RL_Email}: {isAdmin ? (contact?.EMail?.EMailAddress || '') : redacted}</p>
          </article>
        </section>
      ))}
      <br />
    </>
  );
};

PickupContactInformation.defaultProps = {
  contactDetails: {},
};

PickupContactInformation.propTypes = {
  contactDetails: PropTypes.shape(),
};

export default PickupContactInformation;
